import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Restriction } from 'src/app/models/centrex/restriction';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';

@Injectable({
    providedIn: 'root',
})
export class RestrictionService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();
    }

    getRestrictions(): Observable<Restriction[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Restriction[]>(`${this.baseUrl}/api/restrictions`, httpOptions);
    }

    getRestriction(restrictionId: string): Observable<Restriction> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Restriction>(`${this.baseUrl}/api/restrictions/${restrictionId}`, httpOptions);
    }

    addRestriction(restriction: Restriction, globalNotification = true): Observable<Restriction> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('global-notification', String(globalNotification))
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.post<Restriction>(`${this.baseUrl}/api/restrictions`, restriction, httpOptions);
    }

    updateRestriction(restriction: Restriction): Observable<Restriction> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.patch<Restriction>(`${this.baseUrl}/api/restrictions/${restriction.id}`, restriction, httpOptions);
    }

    deleteRestriction(restrictionId: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.delete<Restriction>(`${this.baseUrl}/api/restrictions/${restrictionId}`, httpOptions);
    }
}
